import React from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { push } from 'connected-react-router';
import Formsy from 'formsy-react';
import { Typography, Grid, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import EmailIcon from '@mui/icons-material/MarkEmailRead';
import TextInput from 'components/inputs/TextInput';
import { submissionModelName } from 'utils/contentHelper';
import { verifySubmission } from 'actions/SubmissionActions';

export class VerificationPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.formRef = React.createRef();
  }

  handleSubmit(data, _resetForm, _invalidateForm) {
    const { promotion, submission, verifySubmission } = this.props;

    verifySubmission(promotion.id, data, this.formRef);
  }

  componentDidMount() {
    if (!this.props.submission) {
      this.props.navigateTo('/');
    }
  }

  render() {
    const { submission, promotion, isProcessing, navigateTo } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom align="center">
          Verify {submissionModelName(promotion, true)}
        </Typography>

        {submission &&
          <Grid container spacing={1} justifyContent="center">
            <Typography className="block" variant="headline" gutterBottom align="center">
              {submissionModelName(promotion, true)} ID: {submission.tracking_id}
            </Typography>

            <Grid size={{sm: 8, xs: 11}}>
              {submission.mfa_type == 'email' &&
                <center>
                  <EmailIcon color="primary" fontSize="large" />
                  <Typography variant="body2" paragraph className="gutter-top">
                    You will be sent an email with a link to verify your {submissionModelName(promotion)}.
                    Alternatively, you can <a href="#" onClick={() => this.setState({showForm: true})}>enter the five-digit code</a> sent to your email.
                    If you do not receive an email, please check your spam folder.
                  </Typography>
                </center>
              }

              {submission.mfa_type == 'mobile_number' &&
                <center>
                  <PhoneIcon color="primary" fontSize="large" />

                  <Typography variant="body2" paragraph className="gutter-top">
                    You will be sent a code to your mobile number ending in
                    <b> {submission.mobile_number_last_digits}.</b>
                  </Typography>

                  <Typography variant="body2" paragraph align="center">
                    Enter the code below to verify your {submissionModelName(promotion)}.
                  </Typography>
                </center>
              }

              {(submission.mfa_type == 'mobile_number' || this.state.showForm) &&
                <Formsy noValidate onValidSubmit={this.handleSubmit} ref={this.formRef} style={{textAlign: 'center'}}>
                  <TextInput type="hidden" name="tracking_id" value={submission.tracking_id} />
                  <TextInput type="number" name="verification_code" label="Verification Code" required
                    validations="isLength:5"
                    validationErrors={{isDefaultRequiredValue: "can't be blank", isLength: 'must be 5 digits'}}
                  />

                  <div className="button-container">
                    <Button type="submit" variant="contained" color="primary" disabled={isProcessing}>Submit</Button>
                  </div>
                </Formsy>
              }
            </Grid>
          </Grid>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...state.submission
  };
}

const mapDispatchToProps = {
  verifySubmission: (promotionId, data, formRef) => verifySubmission(promotionId, data, formRef),
  navigateTo: (path) => push(path)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerificationPage));
